import React from 'react';
import { Container, Typography, Grid } from '@material-ui/core';
import Footer from '../footer/Footer';
import { useStyles, InteractiveMapLogic } from './InteractiveMap.module';

const InteractiveMap = () => {
  const classes = useStyles();
  const { translator } = InteractiveMapLogic();

  return (
    <>
      <Container maxWidth="lg" className={classes.containerInteractiveMap}>
        <Grid item xs={12} container justifyContent="center">
          <Typography variant="h3" className={classes.titleInteractiveMap1}>
            {translator('interactiveMap.title1')}
          </Typography>

          <Typography variant="h3" className={classes.titleInteractiveMap2}>
            {' '}
            {translator('interactiveMap.title2')}
          </Typography>
        </Grid>
        <iframe width="700" height="600" allow="local-network-access; geolocation" title="Proyectos eGreen" src="https://egreen.maps.arcgis.com/apps/mapviewer/index.html?configurableview=true&webmap=5d1e8ce3fece4ed2a024db52f41b338a&theme=light&scroll=false&center=-72.81273220018477,-44.29324157541624&scale=72223.819286" ></iframe>
      </Container>
      <Footer />
    </>
  );
};

export default InteractiveMap;
